import { AlertModel } from './AlertModel'
import { IncidentModel } from './IncidentModel'
import { arrayFromJSONValue } from './parser'

export class IncidentFeedModel {
  public alerts: AlertModel[]
  public active: IncidentModel[]
  public recent: IncidentModel[]

  public constructor(alerts: AlertModel[], active: IncidentModel[], recent: IncidentModel[]) {
    this.alerts = alerts
    this.active = active
    this.recent = recent
  }

  public static modelFromJSON(json: any): IncidentFeedModel {
    return new IncidentFeedModel(
      arrayFromJSONValue(json['alerts']).map(value => AlertModel.modelFromJSON(value)),
      arrayFromJSONValue(json['active']).map(value => IncidentModel.modelFromJSON(value)),
      arrayFromJSONValue(json['recent']).map(value => IncidentModel.modelFromJSON(value))
    )
  }

  public mappableIncidents() {
    return this.active.concat(this.recent).filter(incident => incident.isMappable())
  }

  public hasData() {
    return this.alerts.length > 0 || this.active.length > 0 || this.recent.length > 0
  }
}
